import { Media } from '@/models/media.model';
import { Community } from './community.model';
import { Coordinate } from './info.model';

export interface Municipality {
  id: number;
  creationDate?: string;
  updatedDate?: string;
  name: string;
  description: string;
  postalCodes: string[];
  impactRelevant: boolean;
  centerCoordinates: Coordinate;
  media: Media[];
  communities: Community[];
}

export const nameRules = [
  (value: string) => {
    if (value) return true;

    return 'Name is required.';
  },
];

function isPostalCode(v: string): boolean {
  return v.length === 4 && v.match(/^\d{4}$/) !== null;
}

export const postalCodeRules = [
  (value: string[]) => {
    if (!value.every((n) => isPostalCode(n))) {
      return 'Please use numbers only, in sets of 4 ';
    }
    if (value.length) return true;

    return 'Name is required.';
  },
];
